<ng-container *ngIf="{ mitec: mitec$ | async} as vm">
  <ion-header class="ion-no-border">
    <ion-toolbar>
      <ion-title></ion-title>
      <ion-buttons slot="start">
        <ion-back-button defaultHref="/" color="light"></ion-back-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <ion-content fullscreen class="ion-padding" #content>
    <img src="/assets/imgs/logo-blanco.png" />
    <form [formGroup]="form" *ngIf="form">
      <ion-grid>
        <ion-row color="primary" class="ion-justify-content-center">
          <ion-col class="ion-align-self-center" size-md="6" size-lg="5" size-xs="12">
            <div>
              <ion-item (click)="showCampusPicker()" [hidden]="user?.id || registerCampus">
                <ion-label position="floating">Campus*</ion-label>
                <ion-input type="text" [value]="campus" readonly></ion-input>
              </ion-item>
              <ion-item [hidden]="form.controls['type'].value!=='Invitado' || user.id">
                <ion-label>¿Exatec?</ion-label>
                <ion-toggle formControlName="exatec"></ion-toggle>
              </ion-item>
              <ion-item
                [hidden]="(form.controls['type'].value==='Invitado'||form.controls['type'].value==='Superadministrador') && !form.controls['exatec'].value"
              >
                <ion-label position="floating" [hidden]="'Colaborador' === user.type">Matrícula*</ion-label>
                <ion-label position="floating" [hidden]="'Colaborador' !== user.type">Nómina*</ion-label>
                <ion-input
                  type="text"
                  #matricula
                  (ionChange)="refreshEmail(matricula.value)"
                  formControlName="enrollment"
                ></ion-input>
              </ion-item>
              <p
                *ngIf="form.controls['enrollment'].errors && (form.controls['enrollment'].dirty || form.controls['enrollment'].touched)"
                class="danger ion-padding"
              >
                Inválido.
              </p>
              <ion-item [hidden]="form.controls['type'].value==='Representativo'">
                <ion-label position="floating">Nombre*</ion-label>
                <ion-input name="name" type="text" formControlName="name"></ion-input>
              </ion-item>
              <p
                *ngIf="form.controls['name'].errors && (form.controls['name'].dirty || form.controls['name'].touched)"
                class="danger ion-padding"
              >
                Requerido
              </p>
              <ion-item [hidden]="form.controls['type'].value==='Representativo'">
                <ion-label position="floating">Apellidos</ion-label>
                <ion-input name="lastname" type="text" formControlName="lastname"></ion-input>
              </ion-item>
              <ion-item (click)="showGenderPicker()" hidden>
                <ion-label position="floating">Género</ion-label>
                <ion-input type="text" [value]="gender" readonly></ion-input>
              </ion-item>
              <ion-item>
                <ion-label position="floating">E-mail*</ion-label>
                <ion-input name="email" type="email" formControlName="email"></ion-input>
              </ion-item>
              <p
                *ngIf="form.controls['email'].errors && (form.controls['email'].dirty || form.controls['email'].touched)"
                class="danger ion-padding"
              >
                E-mail inválido. Estudiantes únicamente &#64;itesm.mx y &#64;tec.mx permitidos.
              </p>

              <ion-item *ngIf="!user.id || vm.mitec === false">
                <ion-label position="floating">Password*</ion-label>
                <app-show-hide-password>
                  <ion-input
                    name="password"
                    type="password"
                    formControlName="password"
                    (ionChange)="form.controls['password_confirmation'].valid"
                  ></ion-input>
                </app-show-hide-password>
              </ion-item>
              <p
                *ngIf="form.controls['password'].errors && (form.controls['password'].dirty || form.controls['password'].touched)"
                class="danger ion-padding"
              >
                Debe contener al menos 1 mayúscula, 1 caracter especial y 1 número y longitud de al menos 6 dígitos.
              </p>
              <ion-item *ngIf="!user.id || vm.mitec === false">
                <ion-label position="floating">Confirmar contraseña*</ion-label>
                <app-show-hide-password>
                  <ion-input
                    type="password"
                    [value]="user?.password_confirmation"
                    formControlName="password_confirmation"
                  ></ion-input>
                </app-show-hide-password>
              </ion-item>
              <p
                *ngIf="form.controls['password_confirmation'].errors && (form.controls['password_confirmation'].dirty || form.controls['password_confirmation'].touched)"
                class="danger ion-padding"
              >
                Confirmación de contraseña inválida.
              </p>

              <ion-item [hidden]="form.controls['type'].value!=='Invitado' && !user?.id">
                <ion-label position="floating">Celular*</ion-label>
                <ion-input name="phone" type="tel" formControlName="phone"></ion-input>
              </ion-item>
              <p
                *ngIf="form.controls['phone'].errors && (form.controls['phone'].dirty || form.controls['phone'].touched)"
                class="danger ion-padding"
              >
                Requerido.
              </p>
              <ion-item [hidden]="user?.id" class="terms">
                <ion-label>
                  Acepto*
                  <span style="text-decoration: underline" (click)="goTerms()">Términos y condiciones</span>
                </ion-label>
                <span class="checkbox-container">
                  <ion-checkbox ngControl="termsAccepted" (ionChange)="onTermsChecked($event)"></ion-checkbox>
                </span>
              </ion-item>
              <p
                *ngIf="form.controls['termsAccepted'].errors && (form.controls['termsAccepted'].dirty || form.controls['termsAccepted'].touched)"
                class="danger ion-padding"
              >
                Debe aceptar términos y condiciones.
              </p>
              <p class="danger" hidden>*Requeridos</p>
            </div>
            <div *ngIf="errors" class="errors">
              <p>{{errors}}</p>
            </div>

            <div>
              <ion-button
                shape="round"
                fill="outline"
                color="light"
                type="submit"
                [disabled]="form.invalid"
                expand="block"
                *ngIf="!user.id"
                (click)="register()"
              >
                Registrar
              </ion-button>
              <ion-button
                shape="round"
                fill="outline"
                color="light"
                type="submit"
                expand="block"
                [disabled]="!form.dirty"
                *ngIf="user.id"
                (click)="update()"
              >
                Actualizar
              </ion-button>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </form>
  </ion-content>
</ng-container>
